<script>
export default {
  functional: true,
  props: {
    label: {
      type: String,
      required: true,
      default: '',
    },
  },
  render(h, ctx) {
    return <h3 class='exercise-title'>{ctx.props.label}</h3>;
  },
};
</script>

<style lang="scss" scoped>
@import '@design';

.exercise-title {
  font-size: 2.1rem;
  font-weight: 900;
  letter-spacing: -0.3px;
  line-height: 2.4rem;
  margin-bottom: 1.6rem;
}
</style>
